/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type TaskEvaluationConfigOutputFormalCriteriaSource =
  (typeof TaskEvaluationConfigOutputFormalCriteriaSource)[keyof typeof TaskEvaluationConfigOutputFormalCriteriaSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskEvaluationConfigOutputFormalCriteriaSource = {
  default: 'default',
  task_params: 'task_params',
  rubric: 'rubric',
} as const;
